jQuery(document).ready(function ($) {
    $('.slick-slider').slick({
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '30px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10px',
                }
            }
        ]
    });
});